var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { createSlice } from '@reduxjs/toolkit';
import merge from 'lodash/merge';
import omit from 'lodash/omit';
var initialState = {
    external: {
        data: null,
    },
    theme: {},
    config: {},
    bookingLink: {
        data: null,
        loading: false,
        error: null,
    },
};
var deepClone = function (input) {
    // Avoid putting frozen objects from other slices/state into this slice.
    // (This is what typically causes: "Cannot assign to read only property ...")
    try {
        // @ts-ignore
        if (typeof structuredClone === 'function')
            return structuredClone(input);
    }
    catch (e) {
        // ignore
    }
    // Fallback (works for JSON-serializable payloads)
    try {
        return JSON.parse(JSON.stringify(input));
    }
    catch (e) {
        return input;
    }
};
var configSlice = createSlice({
    name: 'common',
    initialState: initialState,
    reducers: {
        setConfig: function (state, action) {
            var payload = deepClone(action.payload);
            merge(state, payload);
        },
        setConfigKey: function (state, action) {
            var key = action.payload.key;
            var payload = deepClone(omit(action.payload, 'key'));
            // Merge into a fresh object to avoid retaining frozen references
            // @ts-ignore
            state[key] = merge({}, state[key], payload);
        },
        setExternal: function (state, action) {
            var payload = deepClone(action.payload);
            state.external = merge({}, state.external, payload);
        },
        mergeState: function (state, action) {
            var payload = deepClone(action.payload);
            merge(state, payload);
        },
        fetchBookingLink: {
            reducer: function (state, action) {
                // Replace object to guarantee it's writable even if a frozen object got assigned previously
                state.bookingLink = __assign(__assign({}, (state.bookingLink || { data: null, loading: false, error: null })), { loading: true, error: null });
            },
            prepare: function (bookingLinkId) {
                return {
                    payload: { bookingLinkId: bookingLinkId },
                };
            },
        },
        fetchBookingLinkSucceeded: function (state, action) {
            state.bookingLink = __assign(__assign({}, (state.bookingLink || { data: null, loading: false, error: null })), { loading: false, data: action.payload });
        },
        fetchBookingLinkFailed: function (state, action) {
            state.bookingLink = __assign(__assign({}, (state.bookingLink || { data: null, loading: false, error: null })), { loading: false, error: action.payload });
        },
    },
});
export var setConfig = (_a = configSlice.actions, _a.setConfig), setExternal = _a.setExternal, mergeState = _a.mergeState, setConfigKey = _a.setConfigKey, fetchBookingLink = _a.fetchBookingLink, fetchBookingLinkSucceeded = _a.fetchBookingLinkSucceeded, fetchBookingLinkFailed = _a.fetchBookingLinkFailed;
export default configSlice.reducer;
